
import { z } from "zod";

export const ContractPartyValues = ["PARTNER", "REMI"] as const;
export const ContractPartySchema = /* @__PURE__ */ z.enum(ContractPartyValues);
export const ContractParty: (typeof ContractPartySchema)["enum"] = { "PARTNER": "PARTNER", "REMI": "REMI" };
export type ContractParty = (typeof ContractPartyValues)[number];
export const ContractPartyDisplayNames = { "PARTNER": "Partner",
"REMI": "Remi", } satisfies Record<ContractParty, string>;
